"use client"

import { useState, useEffect } from "react"

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  // 显示/隐藏按钮的逻辑
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  // 滚动到顶部的函数
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility)
    return () => {
      window.removeEventListener("scroll", toggleVisibility)
    }
  }, [])

  return (
    <>
      {isVisible && (
        <div
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "200px",
            right: "20px",
            cursor: "pointer",
          }}
        >
          <div className="hidden rounded-full p-2 shadow-[0_1px_5px_1px_#00000033] bg-white md:block">
            <svg
              width="25"
              height="25"
              viewBox="0 0 37 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.488281"
                y="0.574219"
                width="36"
                height="36"
                rx="18"
                fill="white"
              />
              <path
                d="M6.59082 8.07422V5.07422H30.5908V8.07422H6.59082ZM17.0908 32.0742V16.7742L13.1908 20.6742L11.0908 18.5742L18.5908 11.0742L26.0908 18.5742L23.9908 20.6742L20.0908 16.7742V32.0742H17.0908Z"
                fill="#CFCFCF"
              />
            </svg>
          </div>
        </div>
      )}
    </>
  )
}

export default ScrollToTop
